import { createContext } from "react"

export function createNamedContext<TValue>(name: string, defaultValue: TValue | null = null) {
    const context = createContext<TValue | null>(defaultValue)
    context.displayName = name

    return context
}
